import React from 'react';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import '@trp-beacon-ui-kit/foundation/css/style.css';
import { Box, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import { PsBeaconButton, PsBeaconModal } from '../shared/BeaconRegister';
import { closeModal } from '../../Utils';

const OutstandingInvite = ({ state }) => {
    const { pendingInvite, archivedGroupSummary, planningGroup, isCustomerWebView } = state;

    const isOutstandingInvite = pendingInvite !== null;
    const isLimbo =
        archivedGroupSummary &&
        archivedGroupSummary.archivedGroupsCount > 0 &&
        planningGroup === null;
    const inviterFirstName = pendingInvite && pendingInvite.inviterFirstName;
    const encodedUrlText = pendingInvite && pendingInvite.encodedUrlText;
    const handleClose = () => {
        closeModal('outstanding-coclient-invite');
    };

    const handleOnClick = () => {
        handleClose();
        window.location.replace(`/usis/advice/fps/invite/${encodedUrlText}`);
    };

    return (
        (isOutstandingInvite || (isOutstandingInvite && isLimbo)) && (
            <PsBeaconModal id="outstanding-coclient-invite" persist>
                <>
                    <Box
                        id="outstanding-coclient-invite-content-container"
                        className="beacon-theme-modern-outlook">
                        <Typography
                            id="outstanding-coclient-invite-title"
                            type="headline" serif scale={200} bold
                            sx={{ paddingBottom: '16px' }}>
                            You&apos;ve been invited to join {inviterFirstName}&apos;s Financial
                            Plan
                        </Typography>
                        <Typography
                            id="outstanding-coclient-invite-text"
                            light
                            sx={{ paddingBottom: '32px' }}>
                            Accepting the invitation will allow you to participate in the
                            household&apos;s Financial Plan, including adding your financial goals
                            and investment accounts.
                        </Typography>
                    </Box>
                    <Box
                        id="action-zone-container"
                        slot="action-zone"
                        className="fixed"
                        style={{
                            width: '100%',
                            display: 'flex',
                            gap: '16px',
                            justifyContent: 'flex-end',
                        }}>
                        <PsBeaconButton
                            id="outstanding-coclient-invite-reject-btn"
                            variant="tertiary"
                            onClick={handleClose}>
                            Decline Invitation
                        </PsBeaconButton>
                        <PsBeaconButton
                            disabled={isCustomerWebView}
                            id="outstanding-coclient-invite-accept-btn"
                            onClick={handleOnClick}>
                            Accept Invitation
                        </PsBeaconButton>
                    </Box>
                </>
            </PsBeaconModal>
        )
    );
};

export default OutstandingInvite;
